import {
  Component,
  EventEmitter,
  ContentChildren,
  ViewChild,
  QueryList,
  Input,
  OnInit,
  OnDestroy,
  HostListener,
  ContentChild
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";

import * as _ from "lodash";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";

import { ConfigService } from "../../config.service";

import { LayoutRouterService } from "./services/router.service";
import { LayoutSidebarService } from "./services/sidebar.service";

import { TemplateComponent } from "../template";

import { LayoutSidebarAvatarComponent } from "./components/sidebar/avatar.component";
import { LayoutSidebarBrandComponent } from "./components/sidebar/brand.component";
import { LayoutSidebarHeaderComponent } from "./components/sidebar/header.component";
import { LayoutSidebarFooterComponent } from "./components/sidebar/footer.component";

import { LayoutHeaderAction } from "./layout.interface";

@Component({
  selector: "uex-layout",
  templateUrl: "layout.component.html",
  host: {
    class: "uex-layout",
    "[class.relative]": "relative"
  }
})
export class LayoutComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private _config: ConfigService,
    private _routerService: LayoutRouterService,
    private _sidebarService: LayoutSidebarService
  ) {
    // Oculta o sidebar na mudanÃ§a de rota em telas pequenas.
    this._subscriptions.push(
      this.router.events
        .pipe(filter(event => event.constructor == NavigationEnd))
        .subscribe(event => {
          this.onRouteChange.emit();
          this._updateSidebarVisible();
        })
    );
    this._subscriptions.push(
      this._routerService.onTemplateUpdate.subscribe(
        (template: TemplateComponent) => {
          setTimeout(() => {
            this.show_header = template.show_layout_header;
            this.show_sidebar = template.show_layout_sidebar;
          }, 0);
        }
      )
    );
    this._subscriptions.push(
      this._routerService.onTemplateUnregister.subscribe(() => {
        setTimeout(() => {
          this.show_header = true;
          this.show_sidebar = true;
        }, 0);
      })
    );
  }

  public show_header: boolean = true;
  public show_sidebar: boolean = true;

  public get title(): string {
    if (
      this._active_component &&
      _.isString(this._active_component.HEADER_TITLE)
    ) {
      return this._active_component.HEADER_TITLE;
    }
  }
  @ContentChildren(LayoutSidebarAvatarComponent) _avatars: QueryList<
    LayoutSidebarAvatarComponent
  >;
  @ContentChildren(LayoutSidebarBrandComponent) _brands: QueryList<
    LayoutSidebarBrandComponent
  >;
  @ContentChildren(LayoutSidebarHeaderComponent) _sidebarHeaders: QueryList<
    LayoutSidebarHeaderComponent
  >;
  @ContentChildren(LayoutSidebarFooterComponent) _sidebarFooters: QueryList<
    LayoutSidebarFooterComponent
  >;

  @Input("action") action: LayoutHeaderAction;

  private _subscriptions: Subscription[] = [];
  private _active_component: any;

  public onRouteChange: EventEmitter<any> = new EventEmitter();

  public relative = false;

  // Oculta o sidebar  ao redimencionar a janela em telas pequenas. TambÃ©m define se deve ser com layout fixo ou nÃ£o.
  @HostListener("window:resize") onResize() {
    this._setSidebarFixed();
    this._updateSidebarVisible();
  }

  public isSidebarFixed(): boolean {
    return this.show_sidebar && this._sidebarService.fixed;
  }

  public hasLeftSidebar(): boolean {
    return this.show_sidebar && !!this._sidebarService.sidebars.left;
  }

  public hasRightSidebar(): boolean {
    return this.show_sidebar && !!this._sidebarService.sidebars.right;
  }

  public isLeftSidebarVisible(): boolean {
    const sidebar = this._sidebarService.sidebars.left;
    return this.show_sidebar && (!!sidebar ? sidebar.visible : false);
  }

  public isRightSidebarVisible(): boolean {
    const sidebar = this._sidebarService.sidebars.right;
    return this.show_sidebar && (!!sidebar ? sidebar.visible : false);
  }

  public ngOnInit() {
    this._restoreSidebarVisibleCache();
    this._subscriptions.push(
      this._sidebarService.onVisibilityChange.subscribe(() =>
        this._saveSidebarVisibleCache()
      )
    );
    this._setRelative();
    this._setSidebarFixed();
    this._updateSidebarVisible();
  }

  public ngOnDestroy() {
    this._subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public onActivateRoute($event) {
    this._active_component = $event;
  }

  public onDeactivateRoute($event) {
    if ($event == this._active_component) {
      this._active_component = null;
    }
  }

  public hideSidebars() {
    this._sidebarService.setVisible("left", false);
    this._sidebarService.setVisible("right", false);
  }

  public isLargeScreen(): boolean {
    const window_width = window.innerWidth;
    return window_width > 1200;
  }

  public getOffsetHeight(): number {
    let height = 0;

    if (this._avatars) {
      const components = this._avatars.toArray();
      components.forEach(
        component => (height += component.elementRef.nativeElement.offsetHeight)
      );
    }

    if (this._brands) {
      const components = this._brands.toArray();
      components.forEach(
        component => (height += component.elementRef.nativeElement.offsetHeight)
      );
    }

    if (this._sidebarHeaders) {
      const components = this._sidebarHeaders.toArray();
      components.forEach(
        component => (height += component.elementRef.nativeElement.offsetHeight)
      );
    }

    if (this._sidebarFooters) {
      const components = this._sidebarFooters.toArray();
      components.forEach(
        component => (height += component.elementRef.nativeElement.offsetHeight)
      );
    }

    return height;
  }

  private _updateSidebarVisible() {
    if (!this.isLargeScreen()) {
      this._sidebarService.setVisible("left", false);
    }
  }

  private _setSidebarFixed() {
    this._sidebarService.setFixed(this.isLargeScreen());
  }

  private _restoreSidebarVisibleCache() {
    let value_left = window.localStorage.getItem("uex-sidebar-left-visible");
    let value_right = window.localStorage.getItem("uex-sidebar-right-visible");

    if (value_left != "0" && value_left != "1") {
      value_left = this.isLargeScreen() ? "1" : "0";
    }
    if (value_right != "0" && value_right != "1") {
      value_right = this.isLargeScreen() ? "1" : "0";
    }

    this._sidebarService.setVisible("left", value_left == "1" ? true : false);
    this._sidebarService.setVisible("right", value_right == "1" ? true : false);
  }

  private _saveSidebarVisibleCache() {
    window.localStorage.setItem(
      "uex-sidebar-left-visible",
      this._sidebarService.getVisible("left") ? "1" : "0"
    );
    window.localStorage.setItem(
      "uex-sidebar-right-visible",
      this._sidebarService.getVisible("right") ? "1" : "0"
    );
  }

  private _setRelative() {
    this.relative = this._config.layout.relative;
  }
}
